module.exports = require("bcrypt");